/* eslint-disable no-unsafe-optional-chaining */
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import fireWhite from '../../../../assets/images/fire-white.svg';
import fire from '../../../../assets/images/fire.svg';
import Text from '../../../../assets/styles/Text';
import Loader from '../../../../components/Loader';
import ReviewComp from '../../../../components/Review';
import { useCreateReview } from '../../../../hooks/mutations/useReviewMutations';
import { useModelVerification } from '../../../../hooks/queries/useMediaUploads';
import {
  useModelReviews,
  useModelTop,
} from '../../../../hooks/queries/useModels';
import { useStore } from '../../../../stores';
import * as styles from './styles';

export default function Review() {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState('');

  const user = useStore((state) => state.user);
  const { id } = useParams();

  // Query reviews
  const { data: reviewsData, isLoading: isLoadingReviews } =
    useModelReviews(id);

  console.log({ reviewsData });

  const {
    reviewsWithUrls = [],
    averageScore = 0,
    scoreDistribution = {
      score5: 0,
      score4: 0,
      score3: 0,
      score2: 0,
      score1: 0,
    },
    hasUpgrade = false,
  } = reviewsData || {};

  // Query model
  const { data: modelData, isLoading: isLoadingModel } = useModelTop(id);

  // Query Verification
  const { data: verification, isLoading: isLoadingVerification } =
    useModelVerification(id);

  const profilePhoto = verification?.urls?.profilePhoto;

  // Mutation para criar review
  const createReviewMutation = useCreateReview();

  const loading = isLoadingReviews || isLoadingVerification || isLoadingModel;

  const options = [
    { value: 5, label: 'Excepcional', id: 5 },
    { value: 4, label: 'Satisfatório', id: 4 },
    { value: 3, label: 'Regular', id: 3 },
    { value: 2, label: 'Insatisfatório', id: 2 },
    { value: 1, label: 'Totalmente frustrado', id: 1 },
  ];

  function switchText(num) {
    const roundedNum = Math.round(num);

    switch (roundedNum) {
      case 1:
        return 'Totalmente Frustado';
      case 2:
        return 'Insatisfatório';
      case 3:
        return 'Regular';
      case 4:
        return 'Satisfatório';
      case 5:
        return 'Excepcional';
      default:
        return 'Sem';
    }
  }

  async function handleSubmit() {
    if (!comment || !rating) {
      toast.error('Dados incompletos');
      return;
    }

    try {
      await createReviewMutation.mutateAsync({
        modelId: id,
        score: rating,
        comment,
      });

      // Limpar form após sucesso
      setComment('');
      setRating('');
    } catch (error) {
      console.error(error);
    }
  }

  const totalReviews = Object.values(scoreDistribution).reduce(
    (sum, val) => sum + val,
    0
  );

  if (loading) return <Loader isLoading={loading} minimal />;

  return (
    <styles.Container id="review">
      <styles.Top>
        <div className="row">
          <styles.GroupImg>
            <img src={profilePhoto} alt="perfil" />
            <Text.H3 $bold>{modelData?.fantasyName}</Text.H3>

            <styles.GroupImgRow $score={averageScore || 0}>
              <div>
                <Text.H3 $bold>{averageScore || 0}</Text.H3>
                <div>
                  <img src={fireWhite} alt="fire" />
                  <img src={fireWhite} alt="fire" />
                  <img src={fireWhite} alt="fire" />
                  <img src={fireWhite} alt="fire" />
                  <img src={fireWhite} alt="fire" />
                </div>
              </div>

              <div>
                <Text.Span>Avaliação geral</Text.Span>
                <Text.P $bold>{switchText(averageScore)}</Text.P>
              </div>
            </styles.GroupImgRow>
          </styles.GroupImg>

          <styles.Star>
            {options.map(({ value, label, id: idLines }) => {
              const count = scoreDistribution[`score${value}`] || 0;
              const percentage =
                totalReviews > 0 ? (count / totalReviews) * 100 : 0;

              return (
                <div key={idLines}>
                  <Text.Span>{label}</Text.Span>
                  <styles.LineName $value={count}>
                    <div>
                      <img src={fire} alt="fire" />
                    </div>
                    <span style={{ width: `${percentage}%` }} />
                  </styles.LineName>
                </div>
              );
            })}
          </styles.Star>
        </div>

        <styles.Form>
          <styles.GroupInput>
            <textarea
              placeholder="Deixe seu comentário"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />

            <div>
              {options
                .sort((a, b) => a.value - b.value)
                .map(({ value, label }, index) => (
                  <styles.Input key={value} $checked={rating === value}>
                    <input
                      type="radio"
                      id={`option-${index}`}
                      name="fire"
                      value={value}
                      checked={rating === value}
                      onChange={(e) => setRating(Number(e.target.value))}
                    />
                    <label htmlFor={`option-${index}`}>
                      <img src={fireWhite} alt={label} />
                      <Text.Span>{label}</Text.Span>
                    </label>
                  </styles.Input>
                ))}
            </div>
          </styles.GroupInput>

          <button
            type="button"
            onClick={handleSubmit}
            disabled={user?.type !== 'client' || createReviewMutation.isPending}
          >
            {(() => {
              if (user?.type !== 'client') {
                return (
                  <Text.Span>
                    Apenas clientes logados podem fazer reviews
                  </Text.Span>
                );
              }
              if (createReviewMutation.isPending) {
                return <Text.Span>Enviando...</Text.Span>;
              }
              return <Text.Span>Deixe o seu Review</Text.Span>;
            })()}
          </button>
        </styles.Form>
      </styles.Top>

      {hasUpgrade && reviewsWithUrls?.length <= 0 && (
        <styles.Empty>
          <Text.H2>Não possui reviews</Text.H2>
        </styles.Empty>
      )}

      {!hasUpgrade && (
        <styles.Private>
          <Text.H2>A modelo(a) não liberou os reviews</Text.H2>
        </styles.Private>
      )}

      {reviewsWithUrls.map((rev) => (
        <ReviewComp review={rev} key={rev.id} />
      ))}
    </styles.Container>
  );
}
